import { NOT_SUITABLE_STAGE } from "../strings";
import { DealStageBadge } from "../common-styling";
import { notSuitableReasons, translatedStaticStages } from "./deal-stages-hash";

const SyncedDealStageBadge = ({ stage, reason = "" }) => {
  return (
    <DealStageBadge $stage={stage}>
      <span>{translatedStaticStages[stage?.name] || stage?.name}</span>
      {stage?.name === NOT_SUITABLE_STAGE && reason ? (
        <span className="ms-1">({notSuitableReasons[reason] || reason})</span>
      ) : (
        ""
      )}
    </DealStageBadge>
  );
};
export default SyncedDealStageBadge;
